import { render } from "./ExamplePages.vue?vue&type=template&id=6253e669"
import script from "./ExamplePages.vue?vue&type=script&lang=js"
export * from "./ExamplePages.vue?vue&type=script&lang=js"

import "./ExamplePages.vue?vue&type=style&index=0&id=6253e669&lang=css"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__